import React, { forwardRef } from 'react';

interface BookMarkProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const BookMark = forwardRef<HTMLElement, BookMarkProps>(({ classes, style = {} }, ref) => {
  return (
    <i ref={ref} className={`fa-regular fa-bookmark ${classes || ''}`} style={style}></i>
  );
});

BookMark.displayName = 'BookMark';
